import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ExportPage from "./pages/ExportPage";
import { ProjectProvider } from "./store/projectContext";
import {
  RenderErrorBoundary,
  installGlobalRenderErrorHandlers,
} from "./components/RenderErrorReporter";

// Capture browser-side errors (window.onerror / unhandledrejection) and beacon
// them to the render server, so a renderer-process crash during export surfaces
// its real cause in the Node logs instead of only a Page.captureScreenshot
// ProtocolError. No-ops outside a render context (no proxy port injected).
installGlobalRenderErrorHandlers();

// Stub renderer globals before React mounts.
// Real implementations are registered inside PlayerProvider on mount.
if (typeof window !== "undefined") {
  if (!window.picmaker_setFrame)      window.picmaker_setFrame      = () => {};
  if (!window.picmaker_collectAssets) window.picmaker_collectAssets = () => [];
  if (!window.picmaker_getClipRegion) window.picmaker_getClipRegion = () => null;
  window.picmaker_isPlayer = false;
  if (window.picmaker_audioEnabled === undefined) window.picmaker_audioEnabled = true;
  if (window.picmaker_videoEnabled === undefined) window.picmaker_videoEnabled = true;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RenderErrorBoundary>
    <BrowserRouter>
      <ProjectProvider>
        <Routes>
           <Route path="/render" element={<ExportPage />} /> 
        </Routes>
      </ProjectProvider>
    </BrowserRouter>
  </RenderErrorBoundary>
);
